"use client";

import styles from "../pages/auth/css/register.module.css";

const Popup = ({ type = "error", message, onClose }) => {
  if (!message) return null;

  const popupClass = type === "error" ? styles.errorPopup : styles.successPopup;
  const contentClass =
    type === "error" ? styles.errorPopupContent : styles.successPopupContent;

  return (
    <div className={popupClass}>
      <div className={contentClass}>
        <span className={styles.closePopup} onClick={onClose}>
          ×
        </span>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default Popup;
